import { InputUI } from '@fourthwall/components';
import React from 'react';
import * as S from './StripeField.styled';
export const StripeField = ({ field, append }) => (React.createElement("div", null,
    React.createElement(InputUI.Box, { "$invalid": !!field.error, "$focused": field.isFocused, "$fullWidth": true },
        React.createElement(S.Input, { ref: field.ref }),
        append),
    field.error && React.createElement(InputUI.Error, null, field.error)));
